import React from "react";
import { contentI18n as i18n } from "../../../common/content_language";

/* eslint-disable react/prop-types */

// Tekrar ("Try Again") modunda seçenek kutuları yanmaz (yeşil/kırmızı vurgu yok),
// böylece cevap açığa çıkmaz. Doğru/yanlış durumu yalnızca bu sabit satırla,
// kontrol butonunun üstünde bildirilir.
//
// `visible=false` iken satır DOM'da kalır ama görünmez (visibility:hidden) —
// böylece yer baştan ayrılır ve mesaj gelince altındaki buton kaymaz.
export default function QuizStatusLine({ correct, visible = true }) {
  return (
    <div
      className={"row quizStatusLine " + (correct ? "correct" : "incorrect")}
      role="status"
      aria-live="polite"
      style={{ visibility: visible ? "visible" : "hidden" }}
    >
      <div
        className={"col-xs-12"}
        style={{
          padding: "10px 14px",
          marginTop: "8px",
          borderRadius: "8px",
          border: `1px solid ${correct ? "#318533" : "#a31111"}`,
          backgroundColor: correct ? "rgba(39,208,124,0.12)" : "rgba(213,26,26,0.12)",
          color: correct ? "#1b5e20" : "#a31111",
          fontWeight: 600,
        }}
      >
        {correct ? i18n.t("MultipleChoice.correctStatus") : i18n.t("MultipleChoice.wrongStatus")}
      </div>
    </div>
  );
}

/* eslint-enable react/prop-types */
